export const ERROR_CODE = {
  BAD_REQUEST: 'BAD_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  NO_ORGANIZATION_ACCESS: 'NO_ORGANIZATION_ACCESS',
  PERSONAL_EMAIL_NOT_ALLOWED: 'PERSONAL_EMAIL_NOT_ALLOWED',
  PERSONAL_EMAIL_LOGIN_DENIED: 'PERSONAL_EMAIL_LOGIN_DENIED',
  LOGIN_METHOD_DENIED: 'LOGIN_METHOD_DENIED',
  AAL2_REQUIRED: 'AAL2_REQUIRED',
  /**
   * AAL1 認証鮮度切れ。MFA は求めず、パスワード再入力（refresh）へ誘導する。
   * パスワード変更（POST /auth/password）等で返る。
   * `MFA_REAUTH_REQUIRED`（AAL2）と取り違えないこと。
   */
  REAUTH_REQUIRED: 'REAUTH_REQUIRED',
  MFA_REAUTH_REQUIRED: 'MFA_REAUTH_REQUIRED',
  ACCESS_CONTROL_DENIED: 'ACCESS_CONTROL_DENIED',
  PERMISSION_AND_ROLE_DENIED: 'PERMISSION_AND_ROLE_DENIED',
  /**
   * 要求した `(台帳, scope)` が組織設定で無効化されている 403。
   * 権限スコープ未保有（ACCESS_CONTROL_DENIED / PERMISSION_AND_ROLE_DENIED）とは異なり、
   * ユーザー自身の権限は足りているため `accessibles` は返らない。
   */
  DATA_SCOPE_DISABLED: 'DATA_SCOPE_DISABLED',
  /**
   * 組織改編の確定で、承知の署名なしにドリフト（プラン外の在籍変化）が検知された 409。
   * 同じエンドポイントは enqueue 失敗でも 409 を返すため、status では判別できない。
   */
  DRIFT_DETECTED: 'DRIFT_DETECTED',
  /** 承知後にドリフト集合が変化した 409。一覧を取り直して再確認させる */
  DRIFT_CHANGED: 'DRIFT_CHANGED',
  /**
   * 送った署名が現行の書式（`v1:<64桁の16進>`）でない 409。BE が署名の書式を上げた後に
   * 古い FE が弾かれる経路。集合の変化（DRIFT_CHANGED）とは原因が違うため分かれている。
   * remediation はどちらも「一覧の再取得＋再確認」で同じ。
   */
  DRIFT_SIGNATURE_OUTDATED: 'DRIFT_SIGNATURE_OUTDATED',
  /** バッチジョブ enqueue の冪等衝突による 409。ドリフトとは無関係 */
  BATCH_JOB_IDEMPOTENCY_CONFLICT: 'BATCH_JOB_IDEMPOTENCY_CONFLICT',
  /** テナントの同時実行上限による 409。ドリフトとは無関係 */
  BATCH_JOB_TENANT_CONCURRENT_LIMIT_EXHAUSTED: 'BATCH_JOB_TENANT_CONCURRENT_LIMIT_EXHAUSTED'
} as const;